import styled from 'styled-components';
import * as color from '../styleVariables';

const Button = styled.button`
  color: ${color.fifthColor};
  padding: 20px;
  background-color: ${color.firstColor}
`;

export default Button;
